var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9446 11.1285V13.4201H21.0557V11.1285C21.0557 9.45747 19.6711 8.07292 18.0001 8.07292C16.2814 8.07292 14.9446 9.45747 14.9446 11.1285ZM12.6529 13.4201V11.1285C12.6529 8.21615 15.04 5.78125 18.0001 5.78125C20.9124 5.78125 23.3473 8.21615 23.3473 11.1285V13.4201H26.4029C27.6442 13.4201 28.6946 14.4705 28.6946 15.7118V25.6424C28.6946 28.1727 26.6416 30.2257 24.1112 30.2257H11.889C9.35862 30.2257 7.30566 28.1727 7.30566 25.6424V15.7118C7.30566 14.4705 8.30827 13.4201 9.59733 13.4201H12.6529ZM13.7987 15.7118C13.1303 15.7118 12.6529 16.237 12.6529 16.8576C12.6529 17.526 13.1303 18.0035 13.7987 18.0035C14.4194 18.0035 14.9446 17.526 14.9446 16.8576C14.9446 16.237 14.4194 15.7118 13.7987 15.7118ZM21.0557 16.8576C21.0557 17.526 21.5331 18.0035 22.2015 18.0035C22.8222 18.0035 23.3473 17.526 23.3473 16.8576C23.3473 16.237 22.8222 15.7118 22.2015 15.7118C21.5331 15.7118 21.0557 16.237 21.0557 16.8576Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagShop);
export default __webpack_public_path__ + "static/media/bag-shop.4204dae8652c5a92053c3e622ef73bd0.svg";
export { ForwardRef as ReactComponent };